import React from 'react'
import Box from '@mui/material/Box'
import { AttentionIcon, defaultTheme, EmtChip, EmtIcon, EmtTypography, useMobile } from 'emt-components-v2'
import { useTranslation } from 'next-i18next'
import { LightBox, LightBoxChips } from './StyledComponents'
import { useEMTState } from '@/store'
import { AnimalProfile } from '@/dataV3/Animal/AnimalProfile'

type Props = React.PropsWithChildren<{ profile: Pick<AnimalProfile, 'gender' | 'displayName' | 'animalOptions'> }>

const DogAbout: React.FC<Props> = ({ profile: { gender, displayName, animalOptions } }) => {
  const { t } = useTranslation('profile')
  const [isMobile, isTablet] = useMobile()

  const { dogAffinityChoices } = useEMTState().configuration

  const needs = dogAffinityChoices.length
    ? dogAffinityChoices.filter((obj) => obj.slug === 'needs')[0].types
    : undefined
  const affinities = dogAffinityChoices.length
    ? dogAffinityChoices.filter((obj) => obj.slug === 'affinities')[0].types
    : undefined

  return (
    <Box sx={{ display: 'flex', flexDirection: isMobile || isTablet ? 'column' : 'row', gap: '24px' }}>
      {/* Is nice with */}
      <LightBox>
        <EmtTypography variant="h5" fontWeight={700}>
          {t('dogAbout.affinities', { context: gender, name: displayName })}
        </EmtTypography>
        <LightBoxChips>
          {affinities &&
            affinities.map((affinitie, k) => (
              <Box key={k}>
                <EmtChip
                  variant={animalOptions[affinitie.slug] ? 'filled' : 'disabled'}
                  color={animalOptions[affinitie.slug] ? 'successlight' : 'greylight'}
                  label={affinitie.sentence.ownerSentence.profileSentence}
                  icon={
                    affinitie.icon?.className === 'emt-attention' ? (
                      <AttentionIcon color={defaultTheme.palette.success[600]} />
                    ) : (
                      <EmtIcon className={affinitie.icon?.className} sx={{ fontWeight: 100 }} />
                    )
                  }
                />
              </Box>
            ))}
        </LightBoxChips>
      </LightBox>
      {/* END is nice with */}

      {/* Dog Need */}
      <LightBox>
        <EmtTypography variant="h5" fontWeight={700}>
          {t('dogAbout.needs', { name: displayName })}
        </EmtTypography>
        <Box sx={{ display: 'flex', flexDirection: 'column', rowGap: '12px', justifyContent: 'start' }}>
          <LightBoxChips>
            {needs &&
              needs.map((need, k) => (
                <Box key={k}>
                  <EmtChip
                    variant={animalOptions[need.slug] ? 'filled' : 'disabled'}
                    color={animalOptions[need.slug] ? 'successlight' : 'greylight'}
                    label={need.sentence.ownerSentence.profileSentence}
                    icon={
                      need.icon?.className === 'emt-attention' ? (
                        <AttentionIcon
                          color={animalOptions[need.slug] ? defaultTheme.palette.success[600] : '#0f0d15'}
                        />
                      ) : (
                        <EmtIcon className={need.icon?.className} sx={{ fontWeight: 100 }} />
                      )
                    }
                  />
                </Box>
              ))}
          </LightBoxChips>
        </Box>
      </LightBox>
      {/* END Dog need */}
    </Box>
  )
}

export default DogAbout
